import { render, staticRenderFns } from "./ProductMappingList.vue?vue&type=template&id=65f1a345"
import script from "./ProductMappingList.vue?vue&type=script&lang=js"
export * from "./ProductMappingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports